// extracted by mini-css-extract-plugin
export default {"wrapper__title":"ForgotPasswordVerificationEmail_wrapper__title__huWb9","wrapper__subtitle":"ForgotPasswordVerificationEmail_wrapper__subtitle__y86Fo"};